import { WordingMultiFitnessYogaPilates } from '@/types';

export const MULTI_FITNESS_YOGA_PILATES_WORDING_DE: WordingMultiFitnessYogaPilates = {
  components_header_media_content: 'Fitness',
  components_header_media_1: 'Für Männer',
  components_header_media_2: 'Für Frauen',
  components_header_media_multi_content_2: 'Yoga',
  components_header_media_multi_content_3: 'Pilates',
  hero_text: 'Trainiere intelligenter, fühl dich besser.',
  hero_button_text: 'Jetzt loslegen',
  components_ressources_subheader_text: 'Anleitungen und Tipps',
  components_ressources_span_text: 'Es vereint die erdverbundene Ausrichtung des Yoga, die kontrollierte Präzision von Pilates und die dynamische Herausforderung des Krafttrainings, um einen ausgewogenen und gesunden Lebensstil zu unterstützen.',
  components_ressources_card_1_title: 'Yoga-Tipps',
  components_ressources_card_1_text: 'Kurzanleitung für besseres Gleichgewicht, Atmung und Fluss.',
  components_ressources_card_2_title: 'Pilates-Tipps',
  components_ressources_card_2_text: 'Einfache Tipps zur Stärkung der Rumpfmuskulatur und Verbesserung der Körperkontrolle.',
  components_notes_and_google_title_1: 'Kraft aufbauen',
  components_notes_and_google_title_2: 'Yoga-Ruhe',
  components_notes_and_google_title_3: 'Pilates-Kern',
  media_content_section_multi_1_subheader_text: 'Schulungsvideos',
  media_content_section_multi_2_subheader_text: 'Yoga-Videos',
  media_content_section_multi_3_subheader_text: 'Pilates-Videos',
  text_media_1: 'Männer',
  text_media_2: 'Frauen',
  page_media_content_menu_biceps: 'Bizeps',
  page_media_content_menu_triceps: 'Trizeps',
  page_media_content_menu_back: 'Zurück',
  page_media_content_menu_chest: 'Brust',
  page_media_content_menu_legs: 'Beine',
  page_media_content_menu_shoulders: 'Schultern',
  page_media_content_menu_abdominals: 'Bauchmuskeln',
  components_text1_subheader_text: 'Gesunde Ernährung für ein aktives Leben',
  components_text1_span_text: 'Gesunde Rezepte, die Ihr Training unterstützen und Ihr Wohlbefinden verbessern.',
  components_footer_text: 'Stärke deinen Körper, bring deinen Geist ins Gleichgewicht und bewege dich mit Sinn – dein Ort für Fitnessstudio, Yoga und Pilates.',
};